import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from './baseQuery';

const tagTypes = [
  'Appointment',
  'Case',
  'Claim',
  'Customer',
  'DataExport',
  'DiagnosisCategory',
  'File',
  'Impersonation',
  'Lead',
  'LeadComment',
  'Location',
  'Market',
  'Message',
  'Patient',
  'Payer',
  'PayerPlan',
  'Provider',
  'Referrer',
  'ReferrerCompany',
  'Region',
  'Report',
  'Review',
  'Session',
  'SessionInstruction',
  'SessionNote',
  'SessionType',
  'Team',
  'VacationTime',
];

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQuery(),
  tagTypes: tagTypes,
  endpoints: () => ({}),
});
